// src/components/ProtectedRoute.js
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase/config';

// 1. Protector exclusivo para ADMINISTRADOR (Mariana)
export function AdminRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setIsAdmin(false);
        setLoading(false);
        return;
      }

      try {
        const userDoc = await getDoc(doc(db, 'usuarios', user.uid));
        if (userDoc.exists()) {
          const data = userDoc.data();
          const rolAdmin =
            data.isAdmin === true ||
            data.rol === 'admin' ||
            user.email === 'marianafitness.app@gmail.com';
          setIsAdmin(rolAdmin);
        } else {
          setIsAdmin(false);
        }
      } catch {
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div style={loadingStyles.wrapper}>
        <div style={loadingStyles.spinner} />
        <p style={loadingStyles.text}>Verificando credenciales...</p>
      </div>
    );
  }

  return isAdmin ? children : <Navigate to="/login" replace />;
}

// 2. Protector para ALUMNOS (UserHomeScreen)
export function UserRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
  const [statusValido, setStatusValido] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setAuthenticated(false);
        setLoading(false);
        return;
      }

      setAuthenticated(true);

      try {
        const userDoc = await getDoc(doc(db, 'usuarios', user.uid));
        if (userDoc.exists()) {
          const data = userDoc.data();
          const esAdmin =
            data.isAdmin === true ||
            data.rol === 'admin' ||
            user.email === 'marianafitness.app@gmail.com';
          const subStatus = (data.subscriptionStatus || data.estado || '').toLowerCase().trim();

          const activo = esAdmin || subStatus === 'active' || subStatus === 'activo';
          setStatusValido(activo);
        } else {
          setStatusValido(false);
        }
      } catch {
        setStatusValido(false);
      } finally {
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div style={loadingStyles.wrapper}>
        <div style={loadingStyles.spinner} />
        <p style={loadingStyles.text}>Cargando panel...</p>
      </div>
    );
  }

  if (!authenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!statusValido) {
    return <Navigate to="/pago-pendiente" replace />;
  }

  return children;
}

const loadingStyles = {
  wrapper: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f8fafc',
    fontFamily: "'Poppins', sans-serif"
  },
  spinner: {
    width: 36,
    height: 36,
    border: '3px solid #e2e8f0',
    borderTop: '3px solid #b03060',
    borderRadius: '50%',
    animation: 'spin 0.8s linear infinite'
  },
  text: {
    marginTop: 14,
    fontSize: 13,
    color: '#64748b',
    fontWeight: '500'
  }
};